import React from "react";
import { useQuickSightComputeOptimizer } from "@/hooks/useComputeOptimizerReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsComputeOptimizerDashboard from "@/components/organisms/ComputeOptimizerDashboard";

function ComputeOptimizerReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightComputeOptimizer();

  return (
    <AWSReportsTemplate
      title="AWS Compute Optimizer Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsComputeOptimizerDashboard />
    </AWSReportsTemplate>
  );
}

export default ComputeOptimizerReports;
